export default __webpack_public_path__ + "static/media/error2.14fe4f7e.gif";